import React from 'react'
import { connect } from 'react-redux'
import { doGetAutoNumberRuleList } from '../../reducers/actions'
import AutoNumberRuleDiv from './AutoNumberRuleDiv'
class AutoNumberRuleListDiv extends React.Component {
  state = {}
  componentDidMount = () => {
    this.handleInitAutoNumberRule()
  }
  handleInitAutoNumberRule = () => {
    const { onSave, onClose, dispatch, AutoNumberID } = this.props
    dispatch(doGetAutoNumberRuleList({
      id: AutoNumberID,
      onEnd: ({ errorMessage, initValues基本信息 }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else if (initValues基本信息) {
          this.setState({ initValues基本信息 })
        }
      }
    }))
  }
  handleAddAutoNumberRule = (data) => {
    const { AutoNumberID } = this.props
    Tyan.pubForm.showDialog('自动编号设置', props => <AutoNumberRuleDiv {...props} id={-1} AutoNumberID={AutoNumberID} onSave={this.handleInitAutoNumberRule} />)
    this.setState({})
  }

  handleEditAutoNumberRule = (data) => {
    const { AutoNumberID } = this.props
    Tyan.pubForm.showDialog('自动编号设置', props => <AutoNumberRuleDiv {...props} id={data.id} AutoNumberID={AutoNumberID} onSave={this.handleInitAutoNumberRule} />)
    this.setState({})
  }

  handlerClose = () => {
    const { onClose } = this.props
    onClose && onClose()
  }

  fieldset模板 = () => {
    return [{
      _grid: '', name: '模板', rowNumbers: true, minRows: 5,
      columns: [
        { _text: '条件', name: '条件', minWidth: 300, flex: 1 },
        { _text: '规则', name: '模板', minWidth: 500, flex: 1 },
      ],
      onDoubleTap: this.handleEditAutoNumberRule,
    }]
  }

  render = () => {
    const {showBody:Body} = this.props

    return <Body data={this} maxWidth={1200}
      controls={
        [
          { _button: '添加', handler: this.handleAddAutoNumberRule },
          { _button: '关闭', handler: this.handlerClose },
        ]}
      fieldsets={[
        { title: '', name: '基本信息', _fieldset: this.fieldset模板(), flex: 1 },
      ]}
    />
  }
}

export default connect()(AutoNumberRuleListDiv)